export default {
  feature: {
    project: false,
    creditAlarm: true,
    reseller: true,
    report: true,
    costByCountry: true,
    accountBalance: true,
    globalCorporation: true,
  },

  accountBalanceTypes: ['RemainingBalance', 'AvailableAmount', 'CreditAmount'],

  billing: {
    dataTransfer: {
      enabled: false,
    },
    cdn: {
      enabled: false,
    },
    consolidated: {
      enabled: true,
    },
    costTrend: {
      enabled: false,
    },
  },

  reseller: {
    enabled: true,
  },

  currencies: {
    default: 'USD',
    cny: {
      enabled: true,
    },
  },


  corporations: {
    international: {
      enabled: true,
    },
    china: {
      enabled: true,
    },
    hongkong: {
      enabled: true,
    },
  },

  timezone: 'Asia/Shanghai',
};
